namespace TabAurous.Stock.Repositories {
    export interface StockByPurchaseApproval {
        id?: number;
        VoucherDate?: string;
        VoucherNo?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        LedgerName?: string;
        PartyCode?: string;
        ProductName?: string;
        ProductCode?: string;
        ImageName?: string;
        CategoryName?: string;
        StockType?: string;
        KaratName?: string;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondWeight?: number;
        StoneWeight?: number;
        MFAmount?: number;
        Remarks?: string;
    }
}
